const formateadorMoneda = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
});

function formatearMonto(valor) {
  return formateadorMoneda.format(Number(valor) || 0);
}

function formatearHora(fechaHora) {
  if (!fechaHora) return '';
  const fecha = new Date(fechaHora.replace(' ', 'T'));
  return fecha.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' });
}

function formatearFechaHora(fechaHora) {
  if (!fechaHora) return '';
  const fecha = new Date(fechaHora.replace(' ', 'T'));
  return fecha.toLocaleString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

const ETIQUETAS_METODO = {
  efectivo: 'Efectivo',
  tarjeta: 'Tarjeta',
  transferencia: 'Transferencia / QR',
};

const ETIQUETAS_MOTIVO = {
  emision: 'Emisión',
  renovacion: 'Renovación',
  reimpresion: 'Reimpresión',
};

function formatearNumeroComprobante(numero) {
  return String(numero).padStart(6, '0');
}

// Clave que identifica UN intento de registrar un cobro: si el pedido se repite (doble clic,
// corte de conexión) con la misma clave, el servidor no cobra dos veces.
function generarClave() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const aleatorio = () => Math.random().toString(36).slice(2, 10);
  return `${Date.now().toString(36)}-${aleatorio()}${aleatorio()}`;
}

// Nombre del operador de un movimiento: si es el que tiene la sesión abierta se muestra su
// usuario; si no (un admin mirando la caja de otro), solo el número.
function nombreOperador(operadorIdDelMovimiento, operadorLogueado) {
  if (operadorLogueado && String(operadorIdDelMovimiento) === String(operadorLogueado.id)) {
    return operadorLogueado.usuario;
  }
  return `Operador #${operadorIdDelMovimiento}`;
}

export {
  formatearMonto,
  formatearHora,
  formatearFechaHora,
  formatearNumeroComprobante,
  generarClave,
  nombreOperador,
  ETIQUETAS_METODO,
  ETIQUETAS_MOTIVO,
};
